import { YoureInvitedModalContentFragment } from '@/models/cms';
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { calculateAge } from '@/helpers';
import { Routes } from '@/router';
import { EnrollmentOptions } from '@/services/loyalty/loyalty.service';
import { CustomerProfile } from '@/models/customer';
import { CountryCode } from '@/store/ui';
import { RewardsPageLoadEvent } from '@/services/analytics/events/rewards-page-load-event';

@Component({
  name: 'CmgYoureInvitedModal',
})
export default class CmgYoureInvitedModal extends Vue {

  youreInvitedModal: YoureInvitedModalContentFragment = {};
  isJoiningRewards = false;

  @Watch('visible')
  async onVisible(newValue: boolean) {
      if (newValue) {
        await this.$services.config.setYoureInvitedModal();
        this.youreInvitedModal = this.$services.config.getYoureInvitedModal() || {};

        this.$services.analytics.applyOne({
                  account: {
                      rewardsReferralInviteViewed: { value: 1 }
                  }
              })
        this.$services.analytics.send(new RewardsPageLoadEvent('referral:logged-in-unenrolled'));
      }
  }  

  get customer(): CustomerProfile | null {
    return this.$appStore.state.customer.profile;
  }


  get visible(): boolean {
    return this.$appStore.state.ui.modals.youreInvitedModal.visible;
  } 

  get isMobile(): boolean {
    return this.$services.ui.isMobile();
  }

  get modalImageSrc(): string {
    return this.$appStore.state.cms.images.logos.medallionReward.default;
  }

  get title(): string {
    return this.youreInvitedModal.title || `You're Invited!`;
  }

  get subtitle(): string {
    return this.youreInvitedModal.subtitle || `<p>Join Chipotle Rewards to order your favorites even faster.</p><p>Earn 100 extra points after placing your first order over $10 by signing up using this link.</p>`;
  }

  get legalCopy(): string {
    return this.youreInvitedModal.legalCopy || `<p>By joining, I am confirming I am 13 years of age or older, will be enrolled in Chipotle Rewards, will receive email updates, promotions and offers from Chipotle, and agree to <a href="https://www.chipotle.com/privacy-policy">Chipotle’s Privacy Policy</a> and <a href="https://www.chipotle.com/rewards-terms">Terms & Conditions</a>.</p>`;
  }

  get primaryCtaText(): string {
    return `Join Rewards`;
  }

  async onPrimaryCtaClick() {
    this.isJoiningRewards = true;

    try {
      const dateOfBirth = this.customer?.dateOfBirth ? new Date(this.customer.dateOfBirth) : undefined;
      const ofAge = (!!dateOfBirth && calculateAge(dateOfBirth) >= 18) || (this.customer?.externallyConfirmed18 ?? false);
      const enrollInEmailMarketing = ofAge && this.customer?.country === CountryCode.US;
      const enrollmentOptions: EnrollmentOptions = {
        customer: this.customer,
        pageTitle: document.title,
        shouldSubscribeToMarketingEmail: enrollInEmailMarketing,
        shouldSubscribeToMarketingSMS: false
      };

      await this.$services.loyalty.enrollInLoyalty(enrollmentOptions);
      this.$services.ui.setModalVisibility('referralJoinSuccessModal', true);

      await this.$services.customer.refreshCustomerProfileInfo();
      this.$services.ui.setModalVisibility('youreInvitedModal', false);

      this.$router.push({ name: Routes.Home });

    } catch (e: any) {
      // TODO-25q6xt: handle errors
      this.$services.logger.error('Something went wrong while enrolling in loyalty', { error: e });
    } finally {
      this.isJoiningRewards = false;
    }
  }
  
  onClose() {
    this.$services.ui.setModalVisibility('youreInvitedModal', false);
    this.$router.push({ name: Routes.Rewards });
  }
}
